export const requiredForwardFieldsV1 = [
    { value: 'u_reclassified_incident_type', label: 'Incidente reclassificado' },
    { value: 'u_oms_classification', label: 'Classificação do incidente de acordo com a OMS' },
    { value: 'u_image_risk', label: 'Risco de Imagem' },
]

export const requiredForwardFieldsV2 = [
    { value: 'u_reclassified_incident_type', label: 'Incidente reclassificado' },
    { value: 'u_oms_classification', label: 'Classificação do incidente de acordo com a OMS' },
    { value: 'u_image_risk', label: 'Risco de Imagem' },
    { value: 'u_probability_occurence', label: 'Frequência este evento ocorre' }
]


export const canForward = (data: any, setErrorMessage: React.Dispatch<React.SetStateAction<string>>): boolean => {
    const uVersion = data?.u_version?.value
    for (const fieldKey of uVersion === 'v1' ? requiredForwardFieldsV1 : requiredForwardFieldsV2) {
        // If the key doesn't exist or the value is falsy, return false
        if (!data?.[fieldKey.value]?.display_value) {
            setErrorMessage(`É necessário preencher o campo ${fieldKey.label} para encaminhar`)
            return false
        }
    }
    setErrorMessage('')
    // If all required fields have truthy values, return true
    return true
}

const requiredDamageLevelsForClassification = [
    'fa57f3dc1bb2e11060d9426fe54bcb83',
    '5b180b9cdb76a1108394816404961964',    
]

export const canFinish = (data: any, setErrorMessage: React.Dispatch<React.SetStateAction<string>>): boolean => {
    if (
        (requiredDamageLevelsForClassification.includes(
            data?.damage_level?.value
        ) ||
            data?.u_image_risk?.value === 'u_image_risk_yes') &&
        !data?.u_incident_classification?.display_value
    ) {
        setErrorMessage(`É necessário preencher o campo notificação interna ou externa para finalizar`)
        return false
    }

    // Verifica se tem disclosure
    const hasDisclosure = data?.u_disclosure?.value === 'u_disclosure_yes' ||  data?.u_disclosure?.value === 'u_disclosure_no'
    
    // Se não tem disclosure, verifica a justificativa
    if (!hasDisclosure && 
        data?.u_managers_review?.display_value?.trim() === ''
    ) {
        setErrorMessage(`É necessário preencher a justificativa da finalização`)
        return false
    }

    return true
}
